import { ParamsList } from '../../validator/shared';

const paramsList: ParamsList = [
    { keyName: 'canonicalUrl', isRequired: true },
    { keyName: 'deviceType', isRequired: true },
    { keyName: 'gaPageType', isRequired: true },
    { keyName: 'encodedVrn', isRequired: false },
    { keyName: 'l1Category', isRequired: false },
    { keyName: 'l2Category', isRequired: false },
];

export default paramsList;
